import { BrandContentMap } from './types';

export const brandContentDE: BrandContentMap = {
  dacia: {
    title: "Zuverlässige Gebrauchte Dacia Deutschland",
    description: "Entdecken Sie zuverlässige gebrauchte Dacia von verifizierten Händlern. Logan, Duster und andere Modelle mit vollständiger Historie und professioneller Prüfung.",
    h1: "Zuverlässige Gebrauchte Dacia - Verifizierte Händler",
    intro: "Dacia bleibt eine der beliebtesten Automarken in Europa. Entdecken Sie, warum gebrauchte Dacia die kluge Wahl für Sicherheit und Zuverlässigkeit sind.",
    badge: "🏆 Beliebteste Budget-Marke",
    models: [
      {
        name: "Dacia Logan",
        description: "Meistverkauftes Auto mit bewährter Zuverlässigkeit über 20 Jahre",
        features: ["Niedrige Wartung", "Teile weit verbreitet", "Bewährte Zuverlässigkeit"]
      },
      {
        name: "Dacia Duster", 
        description: "Erschwinglicher Kompakt-SUV mit Allradantrieb",
        features: ["Vielseitiger SUV", "Niedriger Verbrauch", "Großzügiger Raum"]
      },
      {
        name: "Dacia Sandero",
        description: "Kompaktes und wirtschaftliches Stadtauto", 
        features: ["Perfekt für Stadt", "Wirtschaftlich", "Leicht zu parken"]
      }
    ],
    whyChoose: [
      "Erschwingliche Ersatzteile weit verbreitet",
      "Autorisierte Service-Center bundesweit", 
      "Vollständige Fahrzeughistorie von Experten geprüft",
      "Verifizierte Händler mit voller Transparenz"
    ],
    tips: [
      "Vollständige Servicehistorie prüfen",
      "Technischen Zustand im autorisierten Service prüfen",
      "Alle Originaldokumente anfordern",
      "Alle elektronischen Systeme testen"
    ],
    stats: [
      { value: "20+", label: "Jahre Zuverlässigkeit" },
      { value: "100%", label: "Historie geprüft" },
      { value: "500+", label: "Service-Center" },
      { value: "24/7", label: "Händler-Support" }
    ],
    faqs: [
      {
        question: "Ist Dacia eine gute Wahl für Gebrauchtwagen?",
        answer: "Ja! Dacia ist ideal für Gebrauchtwagen aufgrund bewährter Zuverlässigkeit, niedriger Wartungskosten und weit verbreiteter Teilverfügbarkeit."
      },
      {
        question: "Was sind die beliebtesten Dacia-Modelle?",
        answer: "Logan (20-Jahres-Führer), Duster (beliebter SUV), Sandero (perfekt für Stadt) und Spring (erschwingliches Elektro)."
      },
      {
        question: "Wie überprüfe ich die Historie eines gebrauchten Dacia?",
        answer: "Unsere verifizierten Händler bieten vollständige Fahrzeughistorie, Originaldokumente und professionellen technischen Bericht für jeden Dacia."
      }
    ]
  },

  bmw: {
    title: "BMW kaufen",
    description: "BMW-Angebote von Händlern und Privatverkäufern, mit Preis, Baujahr, Kilometerstand und Fotos. Verkäufer direkt kontaktieren.",
    h1: "BMW kaufen",
    intro: "BMW steht für Exzellenz in deutscher Automobiltechnik. Entdecken Sie gebrauchte BMW mit Top-Leistung, Technologie und Komfort.",
    badge: "BMW",
    models: [
      {
        name: "BMW 3er",
        description: "Premium-Limousine mit perfekter Balance zwischen Leistung und Komfort",
        features: ["Fortschrittliche Technologie", "Sportliche Leistung", "Premium-Komfort"]
      },
      {
        name: "BMW X3", 
        description: "Premium-SUV mit xDrive-Allradantrieb",
        features: ["Vielseitiger SUV", "xDrive serienmäßig", "Premium-Raum"]
      },
      {
        name: "BMW X5",
        description: "Luxus-SUV mit modernster Technologie", 
        features: ["Luxus und Komfort", "Überlegene Leistung", "Innovative Technologie"]
      }
    ],
    whyChoose: ["Serviceheft und Dokumente vor dem Kauf prüfen", "Den Verkäufer nach der FIN für eine unabhängige Prüfung fragen", "Das Fahrzeug in einer Werkstatt Ihrer Wahl prüfen lassen", "Das Abzeichen „Verifizierter Händler“ bezieht sich auf die Firma, nicht auf das Auto"],
    tips: [
      "BMW-Digitalhistorie prüfen",
      "iDrive-Elektronik-Systeme prüfen",
      "xDrive auf gemischten Strecken testen",
      "BMW-Software-Updates überprüfen"
    ],
    stats: [],
    faqs: [
      {
        question: "Warum einen gebrauchten BMW wählen?",
        answer: "BMW bietet Premium-Technologie, sportliche Leistung und hervorragende Werterhaltung, was sie ideal für Gebrauchtwagen mit erhaltenem Wert macht."
      },
      {
        question: "Was sind die beliebtesten BMW-Modelle?",
        answer: "3er (Premium-Limousine), X3 (Kompakt-SUV), X5 (Luxus-SUV) und 5er (Executive-Limousine) sind die gefragtesten."
      },
      {
        question: "Wie überprüfe ich BMW-Technologie bei einem Gebrauchtwagen?",
        answer: "Testen Sie iDrive und Assistenzsysteme bei der Probefahrt, fordern Sie das Serviceheft an und idealerweise eine unabhängige Prüfung. RO Auto Market prüft keine Fahrzeuge."
      }
    ]
  }
};
